import { render, staticRenderFns } from "./followLabelButton.vue?vue&type=template&id=0a6e857e&scoped=true&lang=pug"
import script from "./followLabelButton.vue?vue&type=script&lang=js"
export * from "./followLabelButton.vue?vue&type=script&lang=js"
import style0 from "./followLabelButton.vue?vue&type=style&index=0&id=0a6e857e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e857e",
  null
  
)

export default component.exports